import React from "react";

const NotFound: React.FC = () => {
  return (
    <div>
      <h2>404 Not Found</h2>
      <p>Oops! The page you are looking for does not exist.</p>
      {/* You can add a link to redirect users back to the login page or another valid route */}
    </div>
  );
};

export default NotFound;
